import {takeEvery} from 'redux-saga/effects'
import {GET_BCSV_LOGS} from 'setup/redux/Actions/BiometricCsvLog/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_BCSV_LOGS, fetchData)
}

export default dataSaga
